import React from 'react';
import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';
import { formatCurrency } from '@src/scripts/util/currency';
import CumulativeChart from '../charts/CumulativeChart';

// The Labor calculator's headline is a recurring monthly cashflow, not a
// payoff date — so its results tiles differ from the Praxis ResultsStep
// rather than reusing it directly.
const LaborResultsStep = ( {
	monthlyGrossProfit,
	effectiveMonthlyRate,
	netCashflowMonthly,
	annualNetCashflow,
	cumulativeCashflow,
	currency,
	locale,
} ) => (
	<div className="roi-calculator__step roi-calculator__step--results">
		<h3>{ __( 'Your results', 'sprintray-roi-calculator' ) }</h3>
		<div className="roi-calculator__results-grid">
			<div className="roi-calculator__result-tile">
				<span className="roi-calculator__result-label">
					{ __( 'Gross Profit / Month', 'sprintray-roi-calculator' ) }
				</span>
				<span className="roi-calculator__result-value">
					{ formatCurrency( monthlyGrossProfit, currency, locale ) }
				</span>
			</div>
			<div className="roi-calculator__result-tile">
				<span className="roi-calculator__result-label">
					{ __( 'Lease Rate / Month', 'sprintray-roi-calculator' ) }
				</span>
				<span className="roi-calculator__result-value">
					{ formatCurrency( effectiveMonthlyRate, currency, locale ) }
				</span>
			</div>
			<div className="roi-calculator__result-tile">
				<span className="roi-calculator__result-label">
					{ __( 'Net Cashflow / Month', 'sprintray-roi-calculator' ) }
				</span>
				<span className="roi-calculator__result-value">
					{ formatCurrency( netCashflowMonthly, currency, locale ) }
				</span>
				<span className="roi-calculator__result-hint">
					{ netCashflowMonthly >= 0
						? __(
								'Positive cashflow from month 1.',
								'sprintray-roi-calculator'
						  )
						: __(
								'The lease rate currently exceeds gross profit.',
								'sprintray-roi-calculator'
						  ) }
				</span>
			</div>
			<div className="roi-calculator__result-tile">
				<span className="roi-calculator__result-label">
					{ __( 'Net Cashflow / Year', 'sprintray-roi-calculator' ) }
				</span>
				<span className="roi-calculator__result-value">
					{ formatCurrency( annualNetCashflow, currency, locale ) }
				</span>
			</div>
		</div>

		<div className="roi-calculator__charts-grid">
			<div className="roi-calculator__chart-card">
				<h4>
					{ __( 'Cumulative Cashflow', 'sprintray-roi-calculator' ) }
				</h4>
				<CumulativeChart
					data={ cumulativeCashflow }
					currency={ currency }
					locale={ locale }
				/>
			</div>
		</div>
	</div>
);

LaborResultsStep.propTypes = {
	monthlyGrossProfit: PropTypes.number,
	effectiveMonthlyRate: PropTypes.number,
	netCashflowMonthly: PropTypes.number,
	annualNetCashflow: PropTypes.number,
	cumulativeCashflow: PropTypes.array,
	currency: PropTypes.string,
	locale: PropTypes.string,
};

export default LaborResultsStep;
